<template>
  <div :class="'page-container screen--' + (screen ?? '')">
    <v-container fluid>
      <section
        v-if="title !== undefined && title !== null"
        class="toolbar toolbar--heading"
      >
        <div class="toolbar-content">
          <div class="title-bar">
            <h1 class="toolbar__section-title">{{ title }}</h1>
          </div>

          <div class="theme-bar">
            <v-switch
              v-model="darkToggle"
              inset
              label="Toggle theme"
              class="theme-toggler"
              size="large"
            />
          </div>
        </div>
      </section>

      <slot></slot>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'
import { useThemePreference } from '@/composables/useThemePreference'

defineProps<{ screen?: string; title?: string }>()

const theme = useTheme()
const { mode, isDark } = useThemePreference(theme)

const darkToggle = computed({
  get() {
    return isDark.value
  },
  set(v: boolean) {
    mode.value = v ? 'dark' : 'light'
  }
})
</script>

<style scoped>
.toolbar-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.title-bar {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.toolbar__section-title {
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-bar {
  flex-shrink: 0;
  padding-left: 24px;
  display: flex;
  align-items: center;
}

.theme-toggler {
  --v-input-height: 40px;
}
</style>
